import { getMutedChannels, saveMutedChannels } from '@mimir/web/util/sessionStorage';

export function getChannelMuteStates(): boolean[] {
  const mutedSet = new Set(getMutedChannels() ?? []);
  return Array.from({ length: 16 }, (_, i) => mutedSet.has(i));
}

function setMuted(channels: number[]): void {
  saveMutedChannels(channels.length > 0 ? channels : null);
}

export function setChannelMuteState(channelIndex: number, muted: boolean): void {
  const current = getChannelMuteStates();
  current[channelIndex] = muted;
  setMuted(current.flatMap((muted, i) => muted ? [i] : []));
}
